/* @flow */

import TBody from 'components/UIKit/Table/TBody';
import ErrorSummaryRow from './ErrorSummaryRow';

type ErrorSummaryRowsProps = {
  children: any,
  router: Object
}

export default function ErrorSummaryRows({
  children, router
}: ErrorSummaryRowsProps): React.Element {
  return (
    TBody({
      children: children.map((error, i) => (
        <ErrorSummaryRow key={i} router={router}>{error}</ErrorSummaryRow>
      ))
    })
  );
}
